const mapCategories = {
    'Kontaktstelle': {
        name: {
            de: 'Kontaktstelle',
            fr: 'Kontaktstelle',
            it: 'Kontaktstelle',
        },
        color: '#FFE503',
        icon: {
            iconUrl: '/images/map/marker-yellow-icon.svg',
            shadowUrl: '/images/map/marker-shadow.svg',
            iconSize: [45, 45], // size of the icon
            shadowSize: [55, 55], // size of the shadow
            iconAnchor: [23, 23], // point of the icon which will correspond to marker's location
            shadowAnchor: [27, 15],  // the same for the shadow
            popupAnchor: [0, -25] // point from which the popup should open relative to the iconAnchor
        }
    },
    'Rechtsschutz': {
        name: {
            de: 'Rechtsschutz',
            fr: 'Rechtsschutz',
            it: 'Rechtsschutz',
        },
        color: '#005DA0',
        icon: {
            iconUrl: '/images/map/marker-blue-icon.svg',
            shadowUrl: '/images/map/marker-shadow.svg',
            iconSize: [45, 45], // size of the icon
            shadowSize: [55, 55], // size of the shadow
            iconAnchor: [23, 23], // point of the icon which will correspond to marker's location
            shadowAnchor: [27, 15],  // the same for the shadow
            popupAnchor: [0, -25] // point from which the popup should open relative to the iconAnchor
        }
    },
    'Camping': {
        name: {
            de: 'Camping',
            fr: 'Camping',
            it: 'Camping',
        },
        color: '#FFE503',
        icon: {
            iconUrl: '/images/map/marker-yellow.svg',
            shadowUrl: '/images/map/marker-shadow.svg',
            iconSize: [45, 45], // size of the icon
            shadowSize: [55, 55], // size of the shadow
            iconAnchor: [23, 23], // point of the icon which will correspond to marker's location
            shadowAnchor: [27, 15],  // the same for the shadow
            popupAnchor: [0, -25] // point from which the popup should open relative to the iconAnchor
        }
    },
    'Technisches Zentrum': {
        name: {
            de: 'Technisches Zentrum',
            fr: 'Technisches Zentrum',
            it: 'Technisches Zentrum',
        },
        color: '#FFE503',
        icon: {
            iconUrl: '/images/map/marker-yellow.svg',
            shadowUrl: '/images/map/marker-shadow.svg',
            iconSize: [45, 45], // size of the icon
            shadowSize: [55, 55], // size of the shadow
            iconAnchor: [23, 23], // point of the icon which will correspond to marker's location
            shadowAnchor: [27, 15],  // the same for the shadow
            popupAnchor: [0, -25] // point from which the popup should open relative to the iconAnchor
        }
    },
    'Fahrtraining': {
        name: {
            de: 'Fahrtraining',
            fr: 'Fahrtraining',
            it: 'Fahrtraining',
        },
        color: '#FFE503',
        icon: {
            iconUrl: '/images/map/marker-yellow.svg',
            shadowUrl: '/images/map/marker-shadow.svg',
            iconSize: [45, 45], // size of the icon
            shadowSize: [55, 55], // size of the shadow
            iconAnchor: [23, 23], // point of the icon which will correspond to marker's location
            shadowAnchor: [27, 15],  // the same for the shadow
            popupAnchor: [0, -25] // point from which the popup should open relative to the iconAnchor
        }
    },
    'Swiss Ambulance Rescue': {
        name: {
            de: 'Swiss Ambulance Rescue',
            fr: 'Swiss Ambulance Rescue',
            it: 'Swiss Ambulance Rescue',
        },
        color: '#FFE503',
        icon: {
            iconUrl: '/images/map/marker-yellow.svg',
            shadowUrl: '/images/map/marker-shadow.svg',
            iconSize: [45, 45], // size of the icon
            shadowSize: [55, 55], // size of the shadow
            iconAnchor: [23, 23], // point of the icon which will correspond to marker's location
            shadowAnchor: [27, 15],  // the same for the shadow
            popupAnchor: [0, -25] // point from which the popup should open relative to the iconAnchor
        }
    },
};

export default mapCategories;
